import { createSlice } from "@reduxjs/toolkit";

const AnalyticsSlice = createSlice({
  name: "AnalyticsSlice",
  initialState: {
    analytics: {},
    groupAnaytics:[]
  },

  reducers: {
    AnalyticseGrowth(state, action) {
      state.length = 0;
      state.analytics = action.payload;
      // state=action.payload
      // r
      // eturn
    },
    GroupAnaylicts(state, action) {
       state.groupAnaytics = action.payload;
      // state=action.payload
      // r
      // eturn
    },
  },
});

export { AnalyticsSlice };

export const { AnalyticseGrowth,GroupAnaylicts } = AnalyticsSlice.actions;
